import styled from "styled-components";
import { device } from "../breakpoints";

export const SpotlightSection = styled.section`
  padding: 120px 0;
  background-color: #fff;
  @media ${device.mobile} {
    padding: 40px 16px;
  }
`;
export const SpotlightContent = styled.section`
  width: 1200px;
  margin: 0 auto;
  > h2 {
    font-family: "Raleway";
    font-size: 48px;
    line-height: 64px;
    color: #000;
    font-weight: 400;
  }
  > h3 {
    font-family: "Open Sans";
    font-size: 22px;
    line-height: 30px;
    color: #4a4a4a;
    font-weight: 400;
    margin-top: 8px;
  }
  @media ${device.mobile} {
    width: 100%;
    > h2 {
      font-size: 32px;
      line-height: 34px;
    }
    > h3 {
      font-size: 16px;
      line-height: 22px;
      margin-top: 12px;
    }
  }
`;
export const SliderCont = styled.div`
  margin-top: 35px;
  @media ${device.mobile} {
    margin-top: 24px;
  }
`;
